import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { Payment } from '../../modules/invoices';
import { Button, Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { priceToString } from '../../util/utils';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface InvoicePaymentListComponentProps {
  payments: Payment[];
  openCreateInvoicePaymentModal: () => void;
}

function InvoicePaymentListComponent({
  payments,
  openCreateInvoicePaymentModal,
}: InvoicePaymentListComponentProps) {
  const columns: ColumnsType<Payment> = [
    {
      title: '지급일',
      dataIndex: 'paymentDate',
      align: 'left',
      width: '20%',
      render: (text: any, record: any, index: any) =>
        moment(record.paymentDate).format('YYYY-MM-DD'),
    },
    {
      title: '금액(원)',
      dataIndex: 'amount',
      align: 'right',
      width: '30%',
      render: (value: any, record: any, index: any) =>
        priceToString(record.amount),
    },
    {
      title: '설명',
      dataIndex: 'description',
      align: 'right',
      width: '50%',
    },
  ];

  return (
    <StyledDiv>
      <Row justify={'space-between'}>
        <Col>
          <Title level={5}>지급내역</Title>
        </Col>
        <Col>
          <Button onClick={openCreateInvoicePaymentModal} size="small">
            추가
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table<any>
            rowKey="id"
            columns={columns}
            dataSource={payments}
            pagination={false}
            locale={{
              triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
              triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
              cancelSort: '정렬을 취소하려면 클릭하세요.',
            }}
            summary={(pageData) => {
              let totalAmount = 0;

              pageData.forEach(({ amount }) => {
                totalAmount += amount;
              });
              return (
                <>
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0} align="right">
                      Total:
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={1} align="right">
                      {priceToString(totalAmount)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={2}></Table.Summary.Cell>
                  </Table.Summary.Row>
                </>
              );
            }}
          />
        </Col>
      </Row>
    </StyledDiv>
  );
}
export default InvoicePaymentListComponent;
